/* istanbul ignore file */

import styled from 'styled-components';
import {defaultTheme, headingSizes, textSizes} from '@stencil/build-theme';

export const CenteredSpaceWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const CenteredDivWrap = styled.div(
  props => `  
    display:flex;
    align-items:center;
    justify-content:center;
    `,
);

export const BaseColumnWrap = styled.div(
  props => `
    display:flex;
    flex-direction:column;
    width:100%;
    `,
);

export const FlexWrap = styled.div(
  props => `
    display:flex;
    `,
);

export const FlexItem = styled.div(
  props => `
    display:flex;
    `,
);

export const FlexItemCenter = styled.div(
  props => `
    display:flex;
    align-items: ${props.alignitem || 'center'};
    `,
);

export const FlexCentered = styled.div(
  props => `
    display:flex;
    align-items: ${props.alignitem || 'center'};
    `,
);

/***** Heading Text *****/
export const SectionHeaderSEO = styled.h1`
  ${headingSizes.MediumW1}
`;

export const LargeSectionHeader = styled.h2`
  ${headingSizes.MediumW1}
`;

export const SectionHeader = styled.h3`
  ${headingSizes.MediumW1}
`;

export const SmallSectionHeader = styled.h4`
  ${headingSizes.Small}
`;

/**** anchor link ****/

export const PrimaryLink = styled.a(
  props => `
    color:${props.theme.colors.goBrandBlue.base};
  `,
);

export const PrimarySpanLink = styled.span(
  props => `
    color:${props.theme.colors.goBrandBlue.base};
  `,
);

/**** circular background of arrow icon */

export const CircularDiv = styled.div(
  props => `
  width:2.6rem;
  height:2.6rem;
  background-color: ${props.theme.colors.ash.medium};
  border-radius:50%;
  cursor:pointer;
  margin-left:1rem;
`,
);

/***** Button basic styles */

export const ButtonBase = styled.button(
  props => `
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border:none;
    background-color: ${props.theme.colors.goBrandOrange.base};
    color: ${props.theme.colors.goWhite.base};    
    text-transform: uppercase;
    border-radius: ${props.theme.misc.borderRadius.xxxlarge};
    font-family: Rubik;
    &:focus{
      box-shadow: none;
      outline-offset: 0;
      outline: 0;
    }
  `,
);

export const FlexItemColumn = styled.div(
  props => `
    display:flex;
    flex-direction:column;
    `,
);

export const FlexSpaceBetween = styled.div(
  props => `
    display:flex;
    align-items:center;
    justify-content : space-between;
    width : 100%;
    `,
);

export const HiddenElement = styled.span`
  display: none;
`;
